import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';
import {GlobalQuestionService} from '../../services/global-question.service';

@Component({
    selector: 'app-question-plus-minus',
    templateUrl: './question-plus-minus.component.html',
    styleUrls: ['./question-plus-minus.component.scss'],
    standalone: false
})
export class QuestionPlusMinusComponent implements OnInit {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = false;
  @Output() questionAnswer = new EventEmitter();

  value = 0;
  maxValue = 0;
  minValue = 0;
  maxQuestion: Question;
  minQuestion: Question;
  uniqueControlName = `plus-minus-control-${newGuid()}`;
  childrenQuestions: Question[] = [];
  parameters: any[] = [];

  constructor(private questionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
    
    if (this.question) {
      this.questionService.getChildrenQuestions(this.question?.cent_aq_question_id)
        .subscribe((items: any[]) => {
          
          for (const q of items) {
            if (!this.childrenQuestions.some(c => c.cent_aq_question_id === q.cent_aq_question_id)) {
              this.childrenQuestions.push(Object.assign({}, q));
            }
          }
        });

      if (this.question?.parameter) {
        this.parameters = JSON.parse(this.question?.parameter);
      }

      if (this.parameters?.length) {
        const min = this.parameters?.find(x => x?.parameter === 'min');
        const max = this.parameters?.find(x => x?.parameter === 'max');
        this.minQuestion = this.childrenQuestions.find(x => x?.cent_aq_question_id === +min?.value);
        this.maxQuestion = this.childrenQuestions.find(x => x?.cent_aq_question_id === +max?.value);
        this.minValue = this.question.min_val;
        this.maxValue = this.question.max_val;
        this.value = this.maxValue;
      }

      if (this.question?.answer) {
        this.value = +this.question?.answer;
        
      }
    }
    this.onChange();
  }

  onChange(): void {
    if (this.value < this.minValue) {
      this.value = this.minValue;
    }
    if (this.value > this.maxValue) {
      this.value = this.maxValue;
      
    }
    
    if (this.question && this.value && this.value !== +this.question?.answer) {
      this.question.answer = this.value.toString();
      this.questionAnswer.emit(this.question);
    }
  }

  setStep(add: boolean): void {
    if (add) {
      if (this.maxValue && this.value > this.maxValue) {
        this.value = this.maxValue;
      } else {
        this.value++;
      }
    } else {
      if (this.value !== 0) {
        this.value--;
      }
    }
    this.onChange();
  }
}
